module.exports = __webpack_public_path__ + "img/american-credit-google-review-mike-reinhart.d104eb1.webp";